import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Body1 } from '@sainsburys-tech/fable'
import { NectarFilled } from '@sainsburys-tech/icons'
import PromotionDrawer from '@/javascript/components/Promotion/components/PromotionDrawer'
import { pushEventAndTrack } from '@/javascript/helpers/taggingSerializer'

const NectarPromotionLink = ({ promotions, partNumber, name }) => {
  const [show, setShow] = useState(false)

  if (!promotions || promotions.length === 0) return null

  const totalNectarPoints = promotions.reduce((sum, promo) => sum + promo.value, 0)
  if (totalNectarPoints === 0) return null

  const toggleDrawer = () => setShow(prev => !prev)

  const onClick = () => {
    pushEventAndTrack({
      eventInfo: {
        eventAction: 'PDP Nectar Points Side Drawer Open',
        eventName: 'pdp_nectarPointsSideDrawerOpen'
      }
    })
    toggleDrawer()
  }

  const promotionDrawerOptions = {
    partNumber,
    name,
    promotions,
    totalNectarPoint: totalNectarPoints,
    dataTest: 'promotion-drawer'
  }

  return (
    <>
      <button type='button' onClick={onClick} className='nectar-promotion-text'>
        <NectarFilled className='nectar-icon' />
        <Body1>
          Collect <b>{totalNectarPoints} Nectar </b>points
          <span className='nectar-learn-more' data-testid='promotion-drawer-link'>
            Learn more
          </span>
        </Body1>
      </button>
      <PromotionDrawer show={show} togglePromotionDrawer={toggleDrawer} {...promotionDrawerOptions} />
    </>
  )
}

NectarPromotionLink.propTypes = {
  promotions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired
    })
  ).isRequired,
  partNumber: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
}

export default NectarPromotionLink
